import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Dropdown, DropdownButton, Form, FormControl, Modal } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { useLocation, Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { debounce } from "lodash";
import { API, entityTypes, fileUpload, get, metaTitle } from "../../../config";
import Pagination from "../../common/Pagination";
import Spin from "../../common/Spin";
import BusinessActionButton from "./components/BusinessActionButton";
import AddBusiness from "./AddBusiness";
import { formatPhone } from "../../common/Misc";
import InviteAccountingFirmModal from "./components/InviteAccountingFirmModal";
// import { getClientDetail } from "../clients/components/ClientHelper";
import BusinessStatusGraph from "../../common/BusinessStatusGraph";
import { Legend } from "recharts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquare } from "@fortawesome/free-solid-svg-icons";
import UploadFile from "../../common/UploadFile";
import * as XLSX from 'xlsx';
import cellEditFactory from 'react-bootstrap-table2-editor';
import { Type } from 'react-bootstrap-table2-editor';
import TitleBar from "../../common/TitleBar";
// import paginationFactory from "react-bootstrap-table2-paginator";

const BusinessForClient = () => {
  const [businessLoading, setBusinessLoading] = useState(false);
  const [businessList, setBusinessList] = useState(null);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const params = useParams();
  const search = query.get("search");
  const role = localStorage.getItem("sme-role");
  const clientIde = params?.client_id;
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [showBusiness, setShowBusiness] = useState(false);

  // const [clientIde, setClientIde] = useState(null);

  const [isLoadingDownload, setIsLoadingDownload] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [isImportLoading, setIsImportLoading] = useState(false);
  const [files, setFiles] = useState();
  const [showExcelModal, setShowExcelModal] = useState(false);
  const [excelBusinessData, setExcelBusinessData] = useState();

  // // Fetching of Client Details
  // const fetchClientData = useCallback(async () => {
  //   try {
  //     setBusinessLoading(true);
  //     const clientDetailData = await getClientDetail(clientID);
  //     setClientIde(clientDetailData?.client?.id)
  //     setBusinessLoading(false);
  //   } catch (e) {
  //     const { data } = e;
  //     setBusinessLoading(false);
  //     toast.error(
  //       data &&
  //         data.errors &&
  //         data.errors.myna_error &&
  //         data.errors.myna_error[0]
  //     );
  //   }
  // }, [clientID]);

  // useEffect(() => {
  //   role !== "Client" && fetchClientData();
    
  // }, [fetchClientData, role]);

  const clientId = localStorage.getItem("sme-clientId") === null ? clientIde : localStorage.getItem("sme-clientId");

  const [showInviteAccountingFirm, setShowInviteAccountingFirm] =
    useState(false);

  const handleDelete = () => {
    fetchBusiness();
  };

  const fetchBusiness = useCallback(async () => {
    try {
      setBusinessLoading(true);
      const { data } = await get(
        `${API.GET_BUSINESS}?limit=${limit ? limit : 10}&page=${
          page ? page : 1
        }&search=${searchParam ? searchParam : ""}&sort_column=${
          sortField ? sortField : ""
        }&sort_order=${sortOrder ? sortOrder : ""}&client_id=${
          clientId ? clientId : ""
        }`
      );
      setBusinessLoading(false);
      setLimit(data?.data?.per_page);
      setPage(data?.data?.current_page);
      setTotal(data?.data?.total);
      setFrom(data?.data?.from);
      setTo(data?.data?.to);
      const businessList = data.data.data;
      setBusinessList(businessList);
      return data.data;
    } catch (e) {
      const { data } = e;
      setBusinessLoading(false);
      setBusinessList([]);
      toast.error(
        data &&
          data.errors &&
          data.errors.myna_error &&
          data.errors.myna_error[0]
      );
    }
  }, [clientId, limit, page, searchParam, sortOrder, sortField]);

  const handleHeadClient = async(e, id) => {
    const formData = new FormData();
    formData.append("client_business_id", id);
    formData.append("head_client", e?.target?.checked ? "1" : "0");
    try {
      setBusinessLoading(true);
      const { data } = await fileUpload(`${API.BUSINESS_HEAD_CLIENT}`, formData);
      setBusinessLoading(false);
      setBusinessList([]);
      fetchBusiness();
      return data.data;
    } catch (e) {
      const { data } = e;
      setBusinessLoading(false);
      toast.error(
        data &&
          data.errors &&
          data.errors.myna_error &&
          data.errors.myna_error[0]
      );
    }
  }

  const businessModal = () => {
    fetchBusiness();
  };

  const businessGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        client_id: businessList[i]?.client_id,
        key: businessList[i]?.id,
        business_id: businessList[i]?.id,
        business_name: (
          <Link
            to={{
              pathname: `/business/${businessList[i]?.id}`,
            }}
          >
            {businessList[i]?.business_name}
          </Link>
        ),
        email: businessList[i]?.email ? businessList[i]?.email : "-",
        phone: businessList[i]?.phone
          ? formatPhone(businessList[i]?.phone)
          : "-",
        accounts:
          businessList[i]?.yodlee_accounts?.length > 0
            ? businessList[i]?.yodlee_accounts?.map((item, index) => {
                return (
                  item?.accountStatus === 1 &&
                  <p key={index}>
                    {item?.accountName}
                    {" : "}
                    {item?.accountNumber}
                  </p>
                );
              })
            : "-",
        reconciled_item: businessList[i]?.reconciled_item
          ? businessList[i]?.reconciled_item
          : "0",
        total_transactions: businessList[i]?.total_transactions
          ? businessList[i]?.total_transactions
          : "0",
        status: businessList[i]?.status ? businessList[i]?.status : "-",
        reconciliation_status: (
          businessList[i]?.yodlee_accounts?.length > 0 ?
          <>
            <BusinessStatusGraph 
              data={businessList[i]?.reconciliation_status ? businessList[i]?.reconciliation_status : []} 
              businessId={businessList[i]?.id} 
              accountData={businessList[i]?.yodlee_accounts ? businessList[i]?.yodlee_accounts?.filter((item) => item?.accountStatus === 1) : []}
            />
          </> : '-'
        ),
        head_client: (
          <div className="head-client-check-box-list">
            <input type="radio" id="head_client" name="head_client" defaultChecked={businessList[i]?.head_client === 1 ? true : false} value="1" onChange={(e) => handleHeadClient(e, businessList[i]?.id)} />
          </div>
        ),
        action: (
          <BusinessActionButton
            id={businessList[i]?.id}
            clientId={businessList[i]?.client_id}
            handleDelete={handleDelete}
            businessModal={businessModal}
            setBusinessList={setBusinessList}
          />
        ),
      });
    }
    return items;
  };
  const business = businessGenerator(businessList?.length);

  const renderLegend = (props) => {
    return (
      <div
        style={{
          display: 'flex',
          gap: '5px',
          justifyContent: 'center'
        }}
      >
        <p style={{ margin: '0px' }}>
          <FontAwesomeIcon
            icon={faSquare}
            style={{
              color: '#79AC78'
            }}
          ></FontAwesomeIcon>{' '}
          Reconciled
        </p>
        <p style={{ margin: '0px' }}>
          <FontAwesomeIcon
            icon={faSquare}
            style={{
              color: '#C70039'
            }}
          ></FontAwesomeIcon>{' '}
          Not Reconciled
        </p>
      </div>
    );
  };

  const BusinessColumns = [
    {
      dataField: "business_name",
      text: "Business Name",
      sort: true,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
    },
    {
      dataField: "phone",
      text: "Phone No.",
      sort: true,
    },
    // {
    //   dataField: "mobile",
    //   text: "Mobile No.",
    //   sort: true,
    // },
    // {
    //   dataField: "abn",
    //   text: "ABN",
    //   sort: true,
    // },
    {
      dataField: "accounts",
      text: "Bank Details",
      // sort: true,
    },
    {
      dataField: "reconciliation_status",
      text: (
        <>
          <div
          className="reconciliation-status-header"
          >
            Reconciliation Status
            <Legend
              layout="horizontal"
              wrapperStyle={{
                top: 0,
                right: 0
              }}
              content={renderLegend}
            />
          </div>
        </>
      ),
      style: { 
        width: '500px' 
      }
    },
    {
      dataField: "head_client",
      text: "Head Client",
      // sort: true,
    },
    {
      dataField: "action",
      text: "Action",
      className: "text-center",
      style: { width: "127px" },
    },
  ];

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC"
      );
    }
  };

  useEffect(() => {
    if(clientId){
      fetchBusiness();
    }
    window.document.title = `${metaTitle} | Client Businesses`
  }, [fetchBusiness, clientId]);

  //eslint-disable-next-line
  const debouncedSave = useCallback(
    debounce(nextValue => {
          setSearchParam(nextValue)
          setPage(1)
        }, 300),
    [], 
  );
  
  const handleSearchChange = event => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    if(nextValue?.length >= 2 || nextValue?.length === 0){
      debouncedSave(nextValue);
    }
  };

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
  };

  const handleChangePage = (page) => {
    setPage(page);
  };

  const toggleBusinessModal = () => {
    showBusiness && businessModal();
    setShowBusiness(!showBusiness);
  };

  const handleInviteAccountingFirm = () => {
    setShowInviteAccountingFirm(!showInviteAccountingFirm);
  };

    
  const handleDownload = async () => {
    try {
      setIsLoadingDownload(true);
      const { data } = await get(API.DOWNLOAD_BUSINESS_TEMPLATE);
      const export_report_path = data?.data?.file;
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        a.setAttribute(
          "download",
          file[file.length - 1] || "businessess.xls"
        );
        a.setAttribute("target", "_blank");
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();
        setIsLoadingDownload(false);
      }
      setIsLoadingDownload(false);
    } catch (e) {
      setIsLoadingDownload(false);
      const errors = e.response?.data?.errors;
      Object.keys(errors).forEach((key) => {
        toast.error(errors[key][0]);
      });
    }
  };

  
  const handleImportModal = async () => {
    setShowImport(true);
  };

  const handleImportClose = () => {
    setShowImport(false);
    setIsImportLoading(false);
    setFiles();
  };
  
  const handleExcelClose = () => {
    setSelectedRow([]);
    setShowExcelModal(false);
    setShowImport(false);
    setIsImportLoading(false);
    setFiles();
  };

  const ExcelBusinessColumns = [
    {
      dataField: "business_name",
      text: "Business Name",
      editCellClasses: 'edit-cell-excel-class',
      validator: (newValue) => {
        if(newValue === '' || newValue === undefined || newValue === null){
          return {
            valid: false,
            message: 'Business Name is Required'
          };    
        }
        if(!newValue.match(/^[^!@#)(^%$<>][a-zA-Z\s\d.,&-]*$/)){
          return {
            valid: false,
            message: 'Business name can contain letters, numbers, ampersand(&), dot(.), comma(,), hyphen(-) & spaces.'
          };
        }
        return true;
      }
    },
    {
      dataField: "email",
      text: "Email",
      editCellClasses: 'edit-cell-excel-class',
      validator: (newValue) => {
        if(newValue){
          if(!newValue.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
            return {
              valid: false,
              message: 'Please enter a valid email address'
            };
          }
        }
        return true;
      },
      classes: (cell) => {
        if(cell){
          if(!String(cell).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
            return "error-cell"
          }
        }
      }
    },
    {
      dataField: "phone",
      text: "Phone",
      editCellClasses: 'edit-cell-excel-class',
      validator: (newValue) => {
        if(newValue){
          if(newValue.split(" ").join("").length !== 12){
            return {
              valid: false,
              message: 'Please enter valid phone number'
            };
          }
        }
        return true;
      },
      classes: (cell) => {
        if(cell){
          if(cell.split(" ").join("").length !== 12){
            // toast.error("Enter 9 Digit Phone Number")
            return "error-cell"
          }
        }
      }
    },
    {
      dataField: "mobile",
      text: "Mobile",
      editCellClasses: 'edit-cell-excel-class',
      validator: (newValue) => {
        if(newValue){
          if(newValue.split(" ").join("").length !== 12){
            return {
              valid: false,
              message: 'Please enter valid mobile number'
            };
          }
        }
        return true;
      },
      classes: (cell) => {
        if(cell){
          if(cell.split(" ").join("").length !== 12){
            // toast.error("Enter 9 Digit Mobile Number")
            return "error-cell"
          }
        }
      }
    },
    {
      dataField: "abn",
      text: "ABN",
      editCellClasses: 'edit-cell-excel-class',
      validator: (newValue) => {
        if(newValue){
          let weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
          if(!String(newValue).split(" ").join("").match(/^[\d]{11}$/)){
            return {
              valid: false,
              message: 'Enter 11 Digit ABN Number'
            };
          }
          if(newValue.split(" ").join("").length === 11){
            let newNumber = newValue.split(" ").join("")
            let sum = 0
            weights.forEach((item, index) => {
              let digit = newNumber[index] - (index ? 0 : 1);
              sum += item * digit 
            })
            if((sum%89) !== 0){
             return {
              valid: false,
              message: 'Enter Valid ABN Number'
             }
            }
          }
        }
      },
      classes: (cell) => {
        if(cell){
          let weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
          if(cell.split(" ").join("").length !== 11){
            // toast.error("Enter 11 Digit ABN Number")
            return "error-cell"
          }
          if(cell.split(" ").join("").length === 11){
            let newNumber = cell.split(" ").join("")
            let sum = 0
            weights.forEach((item, index) => {
              let digit = newNumber[index] - (index ? 0 : 1);
              sum += item * digit 
            })
            if((sum%89) !== 0){
             return "error-cell"
            }
          }
        }
      }
    },
    {
      dataField: "entity_type",
      text: "Entity Type",
      editor: {
        type: Type.SELECT,
        options: entityTypes
      },
      editCellClasses: 'edit-cell-excel-class'
    },
    {
      dataField: "ref",
      text: "Reference",
      editCellClasses: 'edit-cell-excel-class',
      validator: (newValue) => {
        if(newValue){
          if(!newValue.match(/^[a-zA-Z\d]*$/)){
            return {
              valid: false,
              message: 'Ref. Number can contain letters, numbers.'
            };
          }
          if(newValue.length > 10){
            return {
              valid: false,
              message: 'Ref. Number can contain maximum 10 Character'
            };
          }
        }
        return true;
      },
      classes: (cell) => {
        if(cell){
          if(cell.length > 10){
            return "error-cell"
          }
        }
      }
    },
    {
      dataField: "account_name",
      text: "Account Name",
      editCellClasses: 'edit-cell-excel-class'
    },
    {
      dataField: "bsb",
      text: "BSB",
      editCellClasses: 'edit-cell-excel-class',
      validator: (newValue) => {
        if(newValue){
          if(String(newValue).match(/[\d]*$/)){
            if(String(newValue).match("-")?.index === 3 || !String(newValue).match("-")){
              if(String(newValue).match("-")){
                if(newValue.split("-").join("").length > 6){
                  return {
                    valid: false,
                    message: 'Enter 6 Digit BSB Number'
                  };
                }
              } else {
                if(newValue.length > 6){
                  return {
                    valid: false,
                    message: 'Enter 6 Digit BSB Number'
                  };
                }
              }
            } else {
              return {
                valid: false,
                message: 'Enter 6 Digit BSB Number'
              };
            }
          }
        }
        return true;
      },
      classes: (cell) => {
        if(cell){
          if(String(cell).match(/[\d]*$/)){
            if(String(cell).match("-")?.index === 3 || !String(cell).match("-")){
              if(String(cell).match("-")){
                if(String(cell).split("-").join("").length > 6){
                  return "error-cell"
                }
              } else {
                if(String(cell).length > 6){
                  return "error-cell"
                }
              }
            } else {
              return "error-cell"
            }
          }
        }
      }
    },
    {
      dataField: "account_number",
      text: "Account Number",
      editCellClasses: 'edit-cell-excel-class',
      validator: (newValue) => {
        if(newValue){
          if(newValue.length > 9){
            return {
              valid: false,
              message: 'Please enter vaild 9 digit Account Number'
            };
          }
        }
        return true;
      },
      classes: (cell) => {
        if(cell){
          if(cell.length > 9){
            return "error-cell"
          }
        }
      }
    },
    {
      dataField: "street",
      text: "Street",
      editCellClasses: 'edit-cell-excel-class'
    },
    {
      dataField: "state",
      text: "State",
      editCellClasses: 'edit-cell-excel-class',
    },
    {
      dataField: "suburb",
      text: "Suburb",
      editCellClasses: 'edit-cell-excel-class',
    },
    {
      dataField: "postal_code",
      text: "Postal Code",
      editCellClasses: 'edit-cell-excel-class',
      validator: (newValue) => {
        if(newValue){
          if(!newValue.match(/^[\d]{4}$/)){
            return {
              valid: false,
              message: 'Postal Code can contain 4 digit numbers.'
            };
          }
        }
        return true;
      },
      classes: (cell) => {
        if(cell){
          if(!String(cell).match(/^[\d]{4}$/)){
            return "error-cell"
          }
        }
      }
    },
  ]
  
  const [ selectedRow, setSelectedRow ] = useState([]);

  let singleSelectedRows = [];
  let allSelectedRows = [];

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: false,
    classes: "selection-row",
    nonSelectable: ['not-select'],
    selected: selectedRow,
    nonSelectableClasses: 'not-selected-class',
    onSelect: (row, isSelect, rowIndex, e) => {
      singleSelectedRows = [...selectedRow];
      if (isSelect) {
        singleSelectedRows = [...selectedRow, row?.key];
      } else {
        singleSelectedRows.splice(selectedRow.indexOf(row?.key), 1);
      }
      setSelectedRow(singleSelectedRows);
    },
    onSelectAll: (isSelect, rows, e) => {
      if(isSelect){
        for(let i=0; i<rows.length; i++){
          if(selectedRow.includes(rows[i].key)){
          } else {
            allSelectedRows.push(rows[i].key);
          }
        }
      }
      else {
        for(let i=0; i<rows.length; i++){
          if(selectedRow.includes(rows[i].key)){
            selectedRow.splice(selectedRow.indexOf(rows[i].key), 1);
          }
        }
      }
      setSelectedRow([...selectedRow, ...allSelectedRows]);
    }
  };

  const ref = useRef();

  const phoneFormat = (value) => {
    if(String(value)?.match(/\+61/)){
      return `+${Number(String(value)?.split(" ")?.join("")).toLocaleString('en-US').replaceAll(",", " ")}`;
    } else {
      return `+61 ${Number(String(value)?.split(" ")?.join("")).toLocaleString('en-US').replaceAll(",", " ")}`;
    }
  }

  const ExcelReader = () => {
    let f = files
    const reader = new FileReader();
    let data = null;
    reader.onload = async(evt) => { // evt = on_file_select event
      /* Parse data */
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, {type:'binary'});
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      data = await XLSX.utils.sheet_to_json(ws, {header:1});
      /* Update state */
      let selectItem = []
      const businessExcelGenerator = (quantity) => {
        const items = [];
        if(
          String(data[0][0]).replace('*', '') !== "Business Name" ||
          data[0][1] !== "Email" ||
          data[0][2] !== "Phone" ||
          data[0][3] !== "Mobile" ||
          data[0][4] !== "ABN" ||
          data[0][5] !== "Entity Type" ||
          data[0][6] !== "Reference" ||
          data[0][7] !== "Account Name" ||
          data[0][8] !== "BSB" ||
          data[0][9] !== "Account Number" ||
          data[0][10] !== "Street" ||
          data[0][11] !== "State" ||
          data[0][12] !== "Suburb" ||
          data[0][13] !== "Postal Code"
        ){
          setShowExcelModal(false);
          setFiles();
          setIsImportLoading(false);
          toast.error("Sorry, File is not in the given format, please download the latest format again");
        } else {
          for (let i = 1; i < quantity; i++) {
            if(data[i].length > 0){
              selectItem.push(i);
              items.push({
                key: i,
                business_name: data[i][0],
                email: data[i][1] ? data[i][1] : "",
                phone: data[i][2] ? phoneFormat(data[i][2]) : "",
                mobile: data[i][3] ? phoneFormat(data[i][3]) : "",
                abn: data[i][4] ? `${Number(String(data[i][4])?.split(" ")?.join("")).toLocaleString("en-US").replaceAll(",", " ")}` : "",
                // eslint-disable-next-line
                entity_type: data[i][5] ? (entityTypes.find((item) => item.value === data[i][5]) ? data[i][5] : "Other" ): "",
                ref: data[i][6] ? data[i][6] : "",
                account_name: data[i][7] ? data[i][7] : "",
                bsb: data[i][8] 
                ?
                 String(data[i][8]).length > 6 ? data[i][8] :
                 String(data[i][8]).match("-") ? data[i][8] : padWithLeadingZeros(Number(data[i][8]), 6).slice(0,3) + '-' + padWithLeadingZeros(Number(data[i][8]), 6).slice(3,6)
                : "",
                account_number: data[i][9] ? padWithLeadingZeros(Number(data[i][9]), 9) : "",
                street: data[i][10] ? data[i][10] : "",
                state: data[i][11] ? data[i][11]: "",
                suburb: data[i][12] ? data[i][12] : "",
                postal_code: data[i][13] ? data[i][13] : "",
              });
            }
          }
        }
        return items;
      };
      setSelectedRow(selectItem)
      setExcelBusinessData(businessExcelGenerator(data?.length))
    };
    reader.readAsBinaryString(f);
  }

  useEffect(() => {
    showExcelModal && ExcelReader();
    // eslint-disable-next-line
  },[showExcelModal])

  const handleExcelModal = () => {
    setShowExcelModal(true)
  }

  function padWithLeadingZeros(num, totalLength) {
    return String(num).padStart(totalLength, '0');
  }

  const handleUpload = async () => {
    if(selectedRow.length > 1000){
      toast.warn("Maximum limit to import businesses is 1000")
    } else {
    if (files) {
      setShowExcelModal(true)
      const formData = new FormData();
      
      formData.append("client_id", clientId);

      for(let i=0; i<selectedRow.length; i++){
        let row = excelBusinessData.find((item) => item.key === selectedRow[i])
        let rowPhone = row.phone.split(" ")
        let rowMobile = row.mobile.split(" ")
        row.phone = rowPhone.join("")
        row.mobile = rowMobile.join("")
        row.abn = row.abn.split(" ").join("")
        row.account_number = padWithLeadingZeros(row.account_number, 9)
        formData.append(`businesses[${i}]`, JSON.stringify(row))
      }

      const config = { headers: { "Content-Type": "multipart/form-data" } };
      try {
        setIsImportLoading(true);
        const { data } = await fileUpload(
          `${API.IMPORT_BUSINESS}`,
          formData,
          config
        );
        setIsImportLoading(false);
        if (data) {
          toast.success(data?.message);
          setSelectedRow([]);
          handleExcelClose();
          fetchBusiness();
          handleImportClose();
        }
        return data?.data;
      } catch (error) {
        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
          if(error?.response?.data?.data?.failedData.length > 0){
            let failData = []
            for(let i=0; i<error?.response?.data?.data?.failedData.length; i++){
              let businessItem = error?.response?.data?.data?.failedData[i]?.data
              if(businessItem?.phone)  {
                businessItem.phone = `+${Number(businessItem?.phone).toLocaleString("en-US").replaceAll(",", " ")}`
              } else {
                businessItem.phone = ""
              }
              if(businessItem?.mobile)  {
                businessItem.mobile = `+${Number(businessItem?.mobile).toLocaleString("en-US").replaceAll(",", " ")}`
              } else {
                businessItem.mobile = ""
              }
              if(businessItem?.abn)  {
                businessItem.abn = `${Number(businessItem?.abn).toLocaleString("en-US").replaceAll(",", " ")}`
              } else {
                businessItem.abn = ""
              }
              failData.push(businessItem);
            }
            setSelectedRow([]);
            setExcelBusinessData(failData);
          }
          fetchBusiness();
          setIsImportLoading(false);
        } else {
          toast.error(error?.message);
          setIsImportLoading(false);
        }
      }
    }
    }
  };

  const handleExcelTableChange = async(type, { data, cellEdit: { rowId, dataField, newValue } }) => {
    const getWithPromiseAll = async() => {
      let temp = await Promise.all(
        data.map(async (row) => {
          if (row?.key === rowId) {
            const newRow = { ...row };
            if(dataField === 'account_number'){
              newRow[dataField] = padWithLeadingZeros(Number(newValue), 9)
            } else if(dataField === 'mobile' || dataField === 'phone'){
              newRow[dataField] = phoneFormat(newValue)
            } else if(dataField === 'abn'){
              newRow[dataField] = `${Number(newValue.split(" ").join("")).toLocaleString("en-US").replaceAll(",", " ")}`
            } else if(dataField === 'bsb'){
              if(String(newValue).match("-")){
                newRow[dataField] = padWithLeadingZeros(Number(String(newValue).split("-").join('')), 6).slice(0,3) + '-' + padWithLeadingZeros(Number(String(newValue).split("-").join('')), 6).slice(3,6)
              } else {
                newRow[dataField] = padWithLeadingZeros(Number(newValue), 6).slice(0,3) + '-' + padWithLeadingZeros(Number(newValue), 6).slice(3,6)
              }
            } else {
              newRow[dataField] = newValue;
            }
            return newRow;
          }
          return row;
        })
      )
      return temp
   }
    const result = await getWithPromiseAll();;
    setExcelBusinessData(result)
  }

  return (
    <>
    <div className="cms-page">
      <div className="page-content-block">
        <div className="full-content-block">
          <TitleBar
            label={"List Of Businesses"}
            businessNameData={false}
            globalSearch={false}
          />          
          <div className="content-details">
            <div className="table-top-btn">
              <div className="search-section">
                <Form>
                  <FormControl
                    onChange={handleSearchChange}
                    type="text"
                    value={searchParamData}
                    placeholder="Search Business"
                  />
                  <div className="table-btn">
                  {searchParamData 
                  ? <Button className="btn-close" onClick={() => {
                    setSearchParamData("")
                    setSearchParam("")
                  }}
                  >x</Button> 
                  : <Button className="fa fa-search">Search</Button>}
                  </div>
                </Form>
              </div>
              <div className="table-btn">
                <div className="border-btn" style={{ alignItems: "center", maxHeight: "39px"}}>
                  <DropdownButton className="info-icon">
                    <Dropdown.Item>
                      <p>Business Name - Required</p>
                    </Dropdown.Item>
                  </DropdownButton>
                  <Button
                    variant="link"
                    disabled={isLoadingDownload}
                    onClick={() => handleDownload()}
                    className="download-template"
                  >
                    Download Template
                  </Button>
                  <Button variant="primary" 
                  onClick={handleImportModal}
                  >
                    Import Businesses
                  </Button>
                </div>
                {(role === "Client" || role === "Client User") && 
                <Button
                  className="small"
                  onClick={() => {
                    handleInviteAccountingFirm();
                  }}
                >
                  Invite Accounting Firm
                </Button>}
                <Button
                  variant="primary"
                  onClick={toggleBusinessModal}
                  data-toggle="modal"
                  data-target="#business"
                >
                  Add New
                </Button>

                {/* <Button variant="primary">Import</Button> */}
              </div>
            </div>
            <div className="custom-table list-business-table">
              {businessLoading && <Spin />}
              <BootstrapTable
                keyField="business_id"
                remote
                data={business}
                columns={BusinessColumns}
                onTableChange={handleTableChange}
                noDataIndication="No Data Found"
              />

              <Pagination
                total={total}
                limit={parseInt(limit)}
                currentPage={page}
                updateLimit={handleUpdateLimit}
                updatePage={handleChangePage}
                from={from}
                to={to}
              />
            </div>
          </div>
          {showBusiness && (
            <AddBusiness
              clientId={clientId}
              toggleBusinessModal={toggleBusinessModal}
              businessModal={businessModal}
              showBusiness={showBusiness}
              setBusinessList={setBusinessList}
            />
          )}
          {showInviteAccountingFirm && (
            <InviteAccountingFirmModal
              showInviteAccountingFirm={showInviteAccountingFirm}
              handleInviteAccountingFirm={handleInviteAccountingFirm}
            />
          )}
        </div>
      </div>
    </div>
    {showImport && (
      <Modal
        size="lg"
        show={showImport}
        onHide={handleImportClose}
        dialogClassName="modal-50w small-popup review-popup small-review"
        aria-labelledby="contained-modal-title-vcenter"
        className="client-section"
        centered
      >
        <Modal.Header className="mb-0" closeButton>
          Import Businesses
        </Modal.Header>
        <Modal.Body>
          <div>
            <UploadFile
              isLoading={isImportLoading}
              setFiles={setFiles}
              files={files}
              handleUpload={handleExcelModal}
              handleCancel={handleImportClose}
              acceptFileFormat="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              ErrorMessage="xls and xlsx"
            />
          </div>
        </Modal.Body>
      </Modal>
    )}
    {showExcelModal && (
      <Modal
        // size="xl"
        show={showExcelModal}
        onHide={handleExcelClose}
        dialogClassName="full-popup large-popup"
        aria-labelledby="contained-modal-title-vcenter"
        className="client-section"
        centered
      >
        <Modal.Header className="mb-0" closeButton>
          Import Businesses
        </Modal.Header>
        <Modal.Body>
          <div className="excel-table-list" style={{padding: "20px"}}>
            {isImportLoading && <Spin />}
            <BootstrapTable
              keyField="key"
              selectRow={selectRow}
              ref={ref}
              remote={{cellEdit: true}}
              data={excelBusinessData ? excelBusinessData : []}
              columns={ExcelBusinessColumns}
              noDataIndication="No Data Found"
              cellEdit={ cellEditFactory({
                mode: 'click',
                blurToSave: true,
                timeToCloseMessage: 30000
              }) }
              onTableChange={handleExcelTableChange}
              // pagination={paginationFactory({
              //   sizePerPage: 10, 
              //   sizePerPageList: [ 
              //     {
              //       text: '10', value: 10
              //     }, 
              //     {
              //       text: '25', value: 25
              //     },
              //     {
              //       text: '50', value: 50
              //     },
              //     {
              //       text: '100', value: 100
              //     }
              //   ],
              //   showTotal: true,
              //   alwaysShowAllBtns: true,
              //   // nextPageText: (<>Next <i class="fa fa-angle-right"></i></>),
              //   // prePageText: (<><i class="fa fa-angle-left"></i> Prev </>)
              // })}
            />
            <div className="excel-list-footer">
              <Button
                variant="primary"
                onClick={handleUpload}
                disabled={selectedRow.length === 0 ? true : false}
                data-toggle="modal"
                data-target="#business"
              >
                Import
              </Button>
              <div>Selected Records: {selectedRow?.length}</div>
            </div>

          </div>
        </Modal.Body>
      </Modal>
    )
    }
    </>
  );
};

export default BusinessForClient;
